<!--  banner logo search bar and menu -->
<div class="mx-auto">
  <section class="max-w-[1440px] mx-auto px-[36px] sm:px-[120px] mt-[40px] bg-blanco sticky top-0 z-40 sm:static sm:z-10">
    <ln-top-banner-search-menu (logoClicked)="GoHome()"></ln-top-banner-search-menu>
  </section>
  <!--  body-->
<!--  class="bg-beige bg-opacity-10"-->
  <section >
    <ng-content select="[body]"> </ng-content>
  </section>
  @if(showFooter) {
    <!--  footer-->
    <section class="max-w-[1440px] mx-auto px-[36px] sm:px-[120px] bg-blanco">
      <ln-footer></ln-footer>
    </section>
  }

</div>



